var app = angular.module('leonardo');

var PortfolioName = function (PortfolioService) {
  return function (pk) {
    var label = 'Invalid portfolio';
    angular.forEach(PortfolioService.getCollection(), function (portfolio) {
      if (portfolio.id == pk) {
        label = portfolio.name;
      }
    });
    return label;
  };
};

app.filter('portfolioName', ['PortfolioService', PortfolioName]);
